import React from 'react';
import { Link } from 'react-router-dom';
import { site } from '../data/site';
export function NotFound() {
  return <section className="mx-auto flex max-w-3xl flex-col items-center px-6 py-24 text-center" data-id="element-404" data-mp="w5av9h9citly">
      <p className="font-display text-6xl font-bold text-safety" data-id="element-405" data-mp="104tgke52x6pb">404</p>
      <h1 className="mt-3 font-display text-3xl font-bold uppercase tracking-tight text-ink" data-id="element-406" data-mp="154po2nczjg9m">
        We could not find that page
      </h1>
      <p className="mt-3 text-base text-steel-500" data-id="element-407" data-mp="1a3964cogk7wp">
        The page may have moved. Start from the services list, or call{' '}
        <a href={site.estimatePhone.href} className="font-semibold text-safety" data-id="element-408" data-mp="1f1133l3ymk7r">
          {site.estimatePhone.display}
        </a>
        .
      </p>
      <div className="mt-7 flex flex-col gap-3 sm:flex-row" data-id="element-409" data-mp="1nue131gvsc0p">
        <Link to="/services" className="rounded-sm bg-safety px-6 py-3.5 text-sm font-bold uppercase tracking-wide text-white transition hover:bg-safety-600" data-id="element-410" data-mp="1sujyky9u0sqp">
          Browse services
        </Link>
        <Link to="/" className="rounded-sm border-2 border-ink px-6 py-3.5 text-sm font-bold uppercase tracking-wide text-ink transition hover:bg-ink hover:text-white" data-id="element-411" data-mp="1nw3zqnqlmd8n">
          Back home
        </Link>
      </div>
    </section>;
}